"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const AdapterDateFns_1 = require("@mui/x-date-pickers/AdapterDateFns");
const CoreContext_1 = require("../_InternalComponents/CoreContext");
const en_US_1 = tslib_1.__importDefault(require("../_InternalUtils/date-fns/locale/en-US"));
const nb_NO_1 = tslib_1.__importDefault(require("../_InternalUtils/date-fns/locale/nb-NO"));
const getAdapterLocaleByLocaleString = (locale) => {
    switch (locale) {
        case "nb-NO":
            return nb_NO_1.default;
        case "en-US":
        default:
            return en_US_1.default;
    }
};
/**
 * Provides a centralized configuration for Material UI components based on the specified theme and locale.
 * It wraps child components with necessary providers for theming and localization. Specifically, it configures:
 * - ThemeProvider for theming support.
 * - LocalizationProvider for date and time localization.
 * It also ensures that styles are injected at the top of the head to override default styles efficiently.
 *
 * @param {ICoreMui5ProviderProps} props - Configuration options for the provider.
 * @returns A React component that wraps children with configured providers.
 * @category Component
 */
const CoreMui5Provider = (props) => {
    const { theme, locale, domain, children } = props;
    return (react_1.default.createElement(styles_1.StyledEngineProvider, { injectFirst: true },
        react_1.default.createElement(styles_1.ThemeProvider, { theme: theme },
            react_1.default.createElement(material_1.CssBaseline, null),
            react_1.default.createElement(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterDateFns_1.AdapterDateFns, adapterLocale: getAdapterLocaleByLocaleString(locale) },
                react_1.default.createElement(CoreContext_1.CoreContextProvider, { domain: domain }, children)))));
};
exports.default = CoreMui5Provider;
